module.exports = __webpack_public_path__ + "media/video-m.a3aaa205.mp4";